import { analyticsCapiEnviar } from '../../../Utils/Services';
import { AnalyticsAdapter, AnalyticsConfig, AnalyticsEventParams, AnalyticsUser, XegueiEventName } from '../types';

declare global {
  interface Window {
    fbq?: any;
  }
}

/**
 * Adapter Meta CAPI — envia eventos server-side via proxy /mobile/analytics/event.
 * NUNCA carrega token CAPI no frontend; o backend (core.api) tem o token.
 *
 * Compartilha eventId com MetaPixelAdapter (dedup automática na Meta).
 */
export class MetaCapiAdapter implements AnalyticsAdapter {
  public readonly name = 'meta-capi';
  private ready = false;
  private empresaId?: string;
  private capiHabilitado = false;

  isReady(): boolean {
    return this.ready && this.capiHabilitado;
  }

  initialize(config: AnalyticsConfig): void {
    this.empresaId = config.empresaId;
    this.capiHabilitado = !!config.capiHabilitado;
    this.ready = !!config.empresaId;
  }

  track(event: XegueiEventName, params: AnalyticsEventParams, user?: AnalyticsUser): void {
    if (!this.isReady() || !this.empresaId) return;

    // fbp/fbc do cookie do Pixel para melhor matching
    const fbp = readCookie('_fbp');
    const fbc = readCookie('_fbc');

    const body: any = {
      empresaId: this.empresaId,
      eventName: event,
      eventId: params.eventId,
      eventTime: Math.floor(Date.now() / 1000),
      eventSourceUrl: params.eventSourceUrl || (typeof window !== 'undefined' ? window.location.href : undefined),
      actionSource: 'website',
      customData: {
        value: params.value,
        currency: params.currency,
        order_id: params.orderId,
        coupon: params.coupon,
        search_string: params.searchTerm,
        contents: params.items?.map((i) => ({ id: i.id, quantity: i.quantidade || 1, item_price: i.valor })),
        content_ids: params.items?.map((i) => i.id).filter(Boolean),
        content_type: params.items && params.items.length ? 'product' : undefined,
      },
      user: user
        ? { email: user.email, telefone: user.telefone, nome: user.nome, externalId: user.externalId }
        : undefined,
      fbp,
      fbc,
    };

    // Fire-and-forget. Erros não devem propagar.
    try {
      fetch(analyticsCapiEnviar.url, {
        method: analyticsCapiEnviar.method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
      }).catch((err) => {
        console.warn('[MetaCapi] envio falhou', err);
      });
    } catch (err) {
      console.warn('[MetaCapi] erro', err);
    }
  }

  page(params?: AnalyticsEventParams): void {
    this.track('PageView', params || {});
  }
}

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const m = document.cookie.match('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)');
  return m ? decodeURIComponent(m[1]) : undefined;
}
